import React from "react";

/**
 * Class name in the admin class list. Shown in full and wrapped: Spring
 * classes are clones of Fall ones with the season at the end, so a name
 * cut off with "..." made every pair look identical.
 */
const ClassNameCell = ({ name, subtitle }) => (
  <div className="min-w-[180px] sm:min-w-[240px]">
    <p className="font-semibold font-manrope text-text-primary text-xs sm:text-sm whitespace-normal break-words">
      {name}
    </p>
    {subtitle && (
      <p className="text-[10px] sm:text-xs font-manrope text-text-muted whitespace-normal break-words">
        {subtitle}
      </p>
    )}
  </div>
);

export default ClassNameCell;
